import React, { Component } from 'react';
import NewUser from './NewUser'
import UpdateUser from './UpdateUser'
import { ErrorCode, RoleGroupId, AccountTypeName } from '../../const'
import * as Business from '../../utils/business'
import * as Http from '../../http'
import Loading from '../../components/Loading'
import { ButtonToolbar, Button } from 'react-bootstrap';

export default class ListRole extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      data: []
    }
  }

  componentDidMount() {
    this.getListRole()
  }

  getListRole = () => {
    Http.queryRoleGroup().then(() => {
      this.setState({
        loading: false,
        data: Http.getRoleGroup()
      })
    })
  }

  deleteItem = username => {
    this.setState({
      data: this.state.data.filter(item => item.username !== username)
    })
  }

  onRoleChange = () => {
    this.getListRole()
  }

  renderRow = (item) => {
    const lstRolesToDisplay = Business.getRawListRole();
    const lstRoleFromDatabase = JSON.parse(item.RoleList) || [];

    for (let i = 0; i < lstRolesToDisplay.length; i++) {
      const roleToDisplay = lstRolesToDisplay[i];
      const roleFromDatabase = lstRoleFromDatabase.find(e => e.roleId === roleToDisplay.roleId && e.roleName === roleToDisplay.roleName);
      if (roleFromDatabase) {
        roleToDisplay.select = roleFromDatabase.select;
      }
    }

    return (
      <tr key={item.RoleGroupId}>
        {
          Business.isHasRole([Business.ROLE_DEFINE_MAP.UPDATE_ROLE])
            ?
            (
              <td>
                <a rel="tooltip"
                  className="btn btn-info btn-simple btn-xs"
                  data-original-title="View Profile"
                  onClick={() => {
                    this.updateUserRef.show(item)
                  }}>
                  {item.RoleGroupName}
                </a>
              </td>
            )
            :
            (
              <td> {item.RoleGroupName} </td>
            )
        }
        {
          lstRolesToDisplay.map(item => (
            <td>
              <input className="form-check-input" type="checkbox" id="inlineCheckbox3" value="option3" disabled
                checked={item.select === '1'} />
            </td>
          ))
        }
      </tr>
    )
  }

  render() {
    if (this.state.loading) return <div style={{ height: Business.getHeightContent() }}><Loading size="small" /></div>

    return Business.isHasRole([Business.ROLE_DEFINE_MAP.CREATE_ROLE, Business.ROLE_DEFINE_MAP.UPDATE_ROLE]) && (
      <div className="card">
        <NewUser ref={ref => this.newUserRef = ref} onRoleChange={this.onRoleChange} />
        <UpdateUser ref={ref => this.updateUserRef = ref} onRoleChange={this.onRoleChange} />
        <div className="header">
          <div style={{ width: '100%', display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' }}>
            <h4 className="title">Role</h4>
            {
              Business.isHasRole([Business.ROLE_DEFINE_MAP.CREATE_ROLE])
              &&
              (
                <ButtonToolbar>
                  <Button bsSize="small" style={{
                    borderRadius: '5px',
                    fontWeight: 600,
                    marginLeft: "auto"
                  }} onClick={() => this.newUserRef.show()}>New Role</Button>
                </ButtonToolbar>
              )
            }
          </div>
        </div>
        <div style={{ height: 15 }} />
        <div className="content table-responsive table-full-width">
          <table className="table table-hover table-striped">
            <thead>
              <tr>
                <th>Role name</th>
                {Business.getAllReportName().map(item => (
                  <th>{item}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {this.state.data.map(this.renderRow)}
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/Role/ListRole.js